<template lang="pug">
v-list(v-if="userRole" dense)
  v-list-item-group(dark)
    template(v-for="item in navigationItems")
      v-list-group.active-group.pl-0(v-if='item.children', :key='item.text')
        template(v-slot:activator='')
          v-list-item-icon.mr-2
            v-icon.white--text {{ item.icon }}
          v-list-item-content
            v-list-item-title.text-wrap.white--text {{ item.text }}
        router-link(:to='subItem.to', v-for='subItem in item.children', :key='subItem.text')
          v-list-item.subitem
            v-list-item-icon.mr-2
              v-icon.white--text {{ subItem.icon }}
            v-list-item-title.text-wrap.ml-0.white--text {{ subItem.text }}
      router-link(:to='item.to', :key='item.to', v-else)
        v-list-item
          v-list-item-icon.mr-2
            v-icon.white--text {{ item.icon }}
          v-list-item-content
            v-list-item-title.text-wrap.white--text {{ item.text }}
</template>

<script>
import checkRole from '@/lib/checkRole';
import haveRights from '@/lib/haveRights';
import { mapGetters } from 'vuex';
import mixinNavigation from './mixinNavigation';
import { ROLES } from '@/constants';
import { ACTION_LIST } from '@/modules/User/constants';

export default {
  name: 'App',
  mixins: [mixinNavigation],
  data: () => ({}),
  computed: {
    ...mapGetters({
      'userRole': 'auth/userRole',
      'user': 'auth/getUser',
    }),

    navigationItems() {
      const [role] = this.userRole;
      if (!role) return [];

      let items = (this.navigation[role] || []);

      if (this.user.parent_id) {
        items = items.filter(({ to }) => to !== '/users');
      }

      if (checkRole(this.userRole, [ROLES.municipality])) {
        items = items.filter(({ to }) => to !== '/monitoring');
      }
      if (!haveRights(this.user, [ACTION_LIST.CAN_CREATE_TEMPLATE])) {
        items = items.filter(({ to }) => to !== '/templates');
      }

      // templates

      return items.sort((a, b) => a.order - b.order);
    },
  },
};
</script>
<style lang="scss">
.v-list-item__icon.v-list-group__header__prepend-icon {
  margin-right: 15px !important;
}
</style>
<style lang="scss">
.active-group {
  &.v-list-group--active {
    background: rgba($color: #000000, $alpha: 0.2);
  }
  .v-list-group__header {
    padding-left: 15px !important;

    .v-list-item__icon {
      margin-right: 10px !important;
    }
  }
}
.subitem {
  &.v-list-item {
    min-height: auto !important;
    padding: 0px 5px 0px 15px;
    transform: translateX(-30px);
    width: calc(100% + 30px);
    transition: all 0.3s;
  }

  &:hover {
    transform: translateX(0px);
    .v-list-item__icon {
      transform: translateX(0px);
    }
  }

  .v-list-item__icon {
    transition: all 0.3s;
    transform: translateX(-30px);
  }
}
</style>
